module.exports = __webpack_public_path__ + "assets/img/stihl_allinclusive_sticker_dk.ea41851a.png";